/* tslint:disable */
/* eslint-disable */
/**
 * EH Commissioning WebAPI 1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import { ErrorResponse, ErrorResponseFromJSON, ErrorResponseFromJSONTyped, ErrorResponseToJSON } from "./ErrorResponse";
import { Project, ProjectFromJSON, ProjectFromJSONTyped, ProjectToJSON } from "./Project";

/**
 *
 * @export
 * @interface ProjectListControllerResponse
 */
export interface ProjectListControllerResponse {
  /**
   *
   * @type {Array<Project>}
   * @memberof ProjectListControllerResponse
   */
  data?: Array<Project> | null;
  /**
   *
   * @type {ErrorResponse}
   * @memberof ProjectListControllerResponse
   */
  error?: ErrorResponse;
}

export function ProjectListControllerResponseFromJSON(json: any): ProjectListControllerResponse {
  return ProjectListControllerResponseFromJSONTyped(json, false);
}

export function ProjectListControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ProjectListControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data")
      ? undefined
      : json["data"] === null
      ? null
      : (json["data"] as Array<any>).map(ProjectFromJSON),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function ProjectListControllerResponseToJSON(value?: ProjectListControllerResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data:
      value.data === undefined ? undefined : value.data === null ? null : (value.data as Array<any>).map(ProjectToJSON),
    error: ErrorResponseToJSON(value.error),
  };
}
